import React, { useState, useEffect } from 'react'
import BackgroundImage from 'gatsby-background-image'
import styled from 'styled-components'
import PopUp from './popUp';
import BusinessCaseForm from './businessCaseForm'
import { colors, breakpoints } from 'utils/utils'
import useScrollBlock from '../hooks/useScrollBlock'

export default props => {
    const { data, form, lang } = props
    const [ isPopupShow, setIsPopupShow ] = useState(false)
    const [ blockScroll, allowScroll ] = useScrollBlock()

    useEffect(() => {
        if(isPopupShow) {
            blockScroll()
        } else {
            allowScroll()
        }
    },[ blockScroll, allowScroll, isPopupShow])

    const openPopup = () => {
        props.changeFlag()
        setIsPopupShow(true)
    }

    const closePopup = () => {
        setIsPopupShow(false)
    }

    const Content = () => {
        return (
            <>
                <Overlay className="mobile"/>
                <BusinessCaseTitle className="mobile">{data.name}</BusinessCaseTitle>
                <BusinessCaseSubTitle className="mobile">{data.subtitle}</BusinessCaseSubTitle>               
            </>
        );
        }

    return (
        <>
            <BusinessCase onClick={openPopup} className="bcase">
                {
                    data.background ?
                        <BusinessCaseBackground fluid={data.background.fluid}>
                            <Content />
                        </BusinessCaseBackground>
                    :
                        <Background>
                            <Content />
                        </Background>
                }
                <BusinessCaseTextBlock>
                    <BusinessCaseTitle>{data.name}</BusinessCaseTitle>
                    <BusinessCaseSubTitle>{data.subtitle}</BusinessCaseSubTitle>
                </BusinessCaseTextBlock>
            </BusinessCase>
            {
                isPopupShow &&
                <PopUp close={closePopup} closeButton="true">
                    <BusinessCaseForm data={data} form={form} lang={lang} close={closePopup}/>
                </PopUp>
            }
        </>
    )
}

// const BusinessCaseTitle = styled.h2`
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     padding: 2rem;
//     font-size: 2.2rem;
//     ${breakpoints.ms} {
//         font-size: 1.8rem;
//     }
// `

// const BusinessCaseText = styled.div`
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     padding: 2rem;
//     ${breakpoints.md} {
//         display: none;
//     }
// `

const BusinessCaseTitle = styled.h2`
    width: 100%;
    padding: 2rem;
    text-align: center;
    font-size: 1.5rem;
    ${breakpoints.xl} {
        font-size: 2rem;
    }
    ${breakpoints.lg} {
        font-size: 2rem;
    }
    ${breakpoints.sm} {
        font-size: 1.5rem;
    }
    ${breakpoints.md} {
        display: none;
    }

    &.mobile {
        display: none;
        ${breakpoints.md} {
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 1rem 2rem;
            text-align: left;
        }
    }
`

const BusinessCaseSubTitle = styled.span`
    position: absolute;
    bottom: -2.5rem;
    right: 0;
    padding: .5rem 2rem;
    text-align: left;
    font-size: 1rem;
    transition: bottom .5s ease-in-out;
    ${breakpoints.md} {
        display: none;
    }

    &.mobile {
        display: none;
        ${breakpoints.md} {
            display: block;
            right: unset;
            bottom: 0;
            left: 0;
            padding: .5rem 2rem;
            text-align: left;
        }
    }
`

const BusinessCase = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    margin-bottom: 1rem;
    background-color: rgba(0,0,0,0.2);
    overflow: hidden;
    top: 0;
    transition: top .5s ease-in-out;
    cursor: pointer;
    &:hover {
        top: -.5rem;
        span${BusinessCaseSubTitle} {
            bottom: 0;
        }
    }
`
const BusinessCaseTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    ${breakpoints.md} {
        display: none;
    }
`

const BusinessCaseBackground = styled(BackgroundImage)`
    position: relative;
    height: 100%;
    background-size: cover;
    max-width: 50%;
    min-width: 50%;
    ${breakpoints.md} {
        width: 100%;
        max-width: unset;
    }
`
    
const Background = styled.div`
    position: relative;
    height: 100%;
    background-color: ${colors.secondary};
    max-width: 50%;
    min-width: 50%;
    ${breakpoints.md} {
        width: 100%;
        max-width: unset;
    }
`

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);

    &.mobile {
        display: none;
        ${breakpoints.md} {
            display: block;
        }
    }
`